import toast from 'jquery-toast-plugin';
import MicroModal from 'micromodal';

/*
 * メッセージ
 */

jQuery(function () {
  $('.message-btn').on('click', function () {
    // プレビュー時動作させない
    var url = location.href;
    if (url.indexOf('preview') !== -1) {
      return false;
    }
    var iCompany_id = $(this).data('company_id');
    $.ajax({
      url: '/ajax/rooms/existenceCheck',
      type: 'GET',
      dataType: 'json',
      data: {
        'company_id': iCompany_id
      }
    })
      // Ajaxリクエストが成功した時発動
      .done((data) => {
        if (data['result'] == 'exist') {
          $(location).attr("href", '/mypage/message/pre-detail/' + iCompany_id);
        } else if (data['result'] == 'noexist') {
          event.preventDefault();
          $('#form-message #to-name').text(data['company_name']);
          $('#form-message input[name="company_id"]').val(iCompany_id);
          $('#form-message input[name="offer_status"]').val(9); // 問い合わせ
          MicroModal.show('modal-message', {
            awaitCloseAnimation: true,
            disableScroll: true
          });
        } else if (data['result'] == 'nologin') {

          $.toast({
            heading: 'ログインしていません',
            text: 'ログインしていません',
            showHideTransition: 'slide',
            icon: 'info',
            position: 'bottom-right',
            hideAfter: 6000
          });
        }
      })
      // Ajaxリクエストが失敗した時発動
      .fail((data) => {

        $.toast({
          heading: 'メッセージ送信に失敗しました',
          text: 'お手数ですが、再度お試しください',
          showHideTransition: 'slide',
          icon: 'error',
          position: 'bottom-right',
          hideAfter: 6000
        });
      })
      // Ajaxリクエストが成功・失敗どちらでも発動
      .always((data) => {

      });
  })

});
